import React, { useState } from "react";
import List from '../../../../Templates/List';
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import moment from "moment-timezone"
import ToolBar from "../../../../Common/Toolbar";
import ListPagination from "../../../../Templates/List/ListPagination";
import { useGetListLastActionsHome } from "../../../../../hooks/services/sKPI/useOfGAP";
import { __OBJECT_STRUCTURE_GetList } from "../../../../../common/ObjectStructures/Trasnversal";
import CLabel from "../../../../Common/CLabel";
import NoDataLayer from "../../../../Common/NoDataLayer";
import './style.css'
import { Icon, ScrollablePane, ScrollbarVisibility, TooltipHost } from "@fluentui/react";
import PropTypes from 'prop-types';
import { __ActionStatus } from "../../../../../common/Dictionaries";

function MessageLastActionsBox(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const {
    } = props;

    //Parametros de componente.
    const [fireSearchActions, setFireSearchActions] = useState(true);

    const [messageEventList, setMessageEventList] = useState(__OBJECT_STRUCTURE_GetList(10));
    const [numberOfItems, setNumberOfItems] = useState(messageEventList.pageSize);
    const [messageDataLength, setMessageDataLength] = useState(0);
    
    useGetListLastActionsHome(
        messageEventList.pageNumber, numberOfItems, messageEventList,
        setMessageEventList, setNumberOfItems,
        fireSearchActions, setFireSearchActions);
    
    const onGetMoreData = () => {
        if (messageEventList.data.length !== messageDataLength) {
            setMessageEventList(prevState => ({
                ...prevState,
                data: null,
                fireUpdate: true, 
                totalRecords: messageEventList.data.length + 2,
                totalPages:  (messageEventList.data.length + 2) / messageEventList.pageSize
            }));
            setMessageDataLength(messageEventList.data.length + 2)
        }
    }
 
    const toolBarItems_Communication  = [
        {
            key: 'showmore',
            text: t('data-lang-btn-showmore'),
            iconProps: { iconName: 'CPlusPlusLanguage' },
            onClick: onGetMoreData,
        },
    ];

    const displayToolBarCommunication = true;

    return (
        <Card className={`mb-2 h-100`}>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{t('data-lang-lbl-lastactions')}</b>
                    <div className='toolbar'>
                        <ToolBar items={ toolBarItems_Communication } styles={{root: {height: "30px"}}} display={ displayToolBarCommunication } />
                    </div>
                </Card.Title>
            </Card.Header>
            <Card.Body id="listLastAcctionsGAP" className="h-100">
                <Row>
                    {
                        messageEventList.data !== null && messageEventList.data.length > 0 &&
                        <ScrollablePane
                            style={{minHeight: "320px", maxHeight: "100%", height: "100%"}}
                            styles={{
                                root: { position: "relative" },
                                contentContainer:{overflowX: "hidden"}
                            }}
                            scrollbarVisibility={ScrollbarVisibility.auto}
                            scrollContainerFocus={true}
                        >
                            <List
                                manipulateLocalData={ true }
                                className="no-compact-list"
                                showHeaders={ false }
                                isHeaderVisible={ false }
                                listLocalStoragePageSizeVariableName="lastGapActions"
                                data={ (messageEventList) }
                                setData={ setMessageEventList }
                                columns={ [
                                {
                                    key: 'all-props-all-props',
                                    name: t('data-lang-lbl-type'),
                                    fieldName: 'all-props-all-props',
                                    onRender:(item) => {

                                        const flyItemData = __ActionStatus.find(x => x.key === item.statusId);

                                        const dateToolTipValue = item.beginDate !== null && item.endDate !== null ? 
                                        `${moment(item.beginDate).format('DD/MM/YYYY')} ${t('data-lang-lbl-to')} ${moment(item.endDate).format('DD/MM/YYYY')}` :
                                        (item.beginDate !== null) ? moment(item.beginDate).format('DD/MM/YYYY') : (item.endDate !== null ? moment(item.endDate).format('DD/MM/YYYY') : t('data-lang-lbl-nodata') )
                                    
                                        const circleStyle = {
                                            width: "40px",
                                            height: "40px",
                                            backgroundColor: flyItemData.circleColor,
                                            borderRadius: '50%',
                                            padding: '10px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        };

                                        const html =   <Row className="mx-1">
                                                            <Col className="col-auto my-auto d-flex justify-content-center">
                                                                <div style={circleStyle}>
                                                                    <Icon iconName={flyItemData.iconName} style={{ fontSize: "20px", color: flyItemData.iconColor }} />
                                                                </div>
                                                            </Col>
                                                            <Col>
                                                                <Row>
                                                                    <Col className='px-0' style={{overflow: "hidden", whiteSpace: "nowrap"}}>
                                                                        <Row>
                                                                            <Col>
                                                                                <TooltipHost content={ item.causeName } >
                                                                                    <div style={{width: "10px"}}>{ item.causeName }</div>
                                                                                </TooltipHost>
                                                                            </Col>
                                                                            <Col className='col-auto me-1'>
                                                                                <TooltipHost content={ dateToolTipValue } >
                                                                                    <Icon iconName="Calendar" style={{ fontSize: "14px" }} />
                                                                                </TooltipHost>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col className='px-0' style={{fontSize: "12px", overflow: "hidden", whiteSpace: "nowrap"}}>
                                                                        <TooltipHost content={ item.action } >
                                                                            <div style={{width: "10px"}}>{ `${t('data-lang-lbl-action')}: ${item.action}` }</div>
                                                                        </TooltipHost>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>

                                        return  html;
                                    }
                                }] }
                            />   
                        </ScrollablePane >
                    }  
                    <NoDataLayer display={messageEventList.data === null || messageEventList.data.length === 0} text={t('data-lang-lbl-nodata')} />                   
                </Row>
            </Card.Body>
            <Card.Footer>
                <ListPagination
                    listLocalStoragePageSizeVariableName="lastGapActions"
                    data={ (messageEventList !== null ? messageEventList : []) }
                    setData={ setMessageEventList } />
            </Card.Footer>
        </Card>
    );
}

///Proptypes
MessageLastActionsBox.propTypes = {
};

export default MessageLastActionsBox;

